<template lang="pug">
v-app
  v-container(fill-height)
    v-layout(align-center)
      v-flex(xs12 sm6 class='controls' align-center)
        h3(class='title mb-4') 404 Not Found
        div(class='font-weight-light')
          | Сервер понял запрос, но не нашёл соответствующего ресурса по
          | указанному URI. Если серверу известно, что по этому адресу был
          | документ, то ему желательно использовать код 410 вместо этого.
          | Этот код может использоваться вместо 403, если требуется
          | тщательно скрыть от посторонних глаз определённые ресурсы.
        v-divider(class='my-4')
        v-btn(
          @click='$router.go(-1)'
          color='primary'
          depressed
        )
          v-icon(left) keyboard_backspace
          span Вернуться назад
        v-btn(
          @click='$router.push({ name: "Index" })'
          color='primary'
          flat
        )
          span Главная страница
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.controls >>> [class*='v-btn--depressed'] {
  margin-left: 0;
}
</style>
